var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('ModalStackComponent',{ref:"modalStack",attrs:{"root":_vm.root}}),_vm._v(" "),(_vm.showApiBadge)?_c('div',{staticClass:"api-env-badge"},[_vm._v("\n        "+_vm._s(_vm.apiBadgeText)+"\n    ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }